const messages = {
  title: "Persone di contatto e numeri di assistenza",
  subtitle: "Il vostro contatto personale presso Bridgestone",
  description:
    "Siamo sempre a vostra disposizione! Trovate il vostro contatto personale Bridgestone sul sito<br/>per la vostra regione o semplicemente mettetevi in contatto con il nostro competente personale del servizio clienti.",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Team commercio pneumatici",
    car: "Team concessionarie auto",
    lkw: "Team autocarri",
    em_otr: "Team EM/OTR",
    farm_tractor: "Team trattori agricoli",
    bandag: "Team Bandag",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "Contatti e assistenza",
      description:
        "Benvenuti nell'area di servizio BRIDGESTONE PLUS. Qui troverete i recapiti del team di assistenza e la possibilità di inviare reclami sui prodotti tramite un modulo.",
    },
    categories: {
      service: {
        description:
          "Numero di assistenza per la vostra regione e contatto e-mail",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
